export function resultsTransformer(data, queryName) {
    if (!data || !transformers[queryName]) { return data; }

    return transformers[queryName](data);
}

const transformers = {

};


/**
 * Safely parse JSON data (honors/scholars fields)
 * @param {string|Object} data - Data that might be JSON string or already parsed
 * @param {string} fieldName - Field name for error logging
 * @returns {Object|null} Parsed object or null
 */
export function safeParseJsonField(data, fieldName = 'data') {
    if (!data) return null;

    // Already parsed
    if (typeof data === 'object') return data;

    // Parse JSON string
    if (typeof data === 'string') {
        try {
            return JSON.parse(data);
        } catch (error) {
            console.error(`Error parsing ${fieldName} data:`, error);
            return null;
        }
    }

    return null;
}

/**
 * Create dynamic scholars data for REQUEST_PREFERENCES flow
 * @param {Object} honorsData - Honors application data
 * @returns {Object} Generated scholars data
 */
export function createScholarsInvitationData(honorsData) {
    return {
        emplid: honorsData.emplid,
        status: "INPROGRESS",
        selfServiceOpen: false,
        decision: null,
        preferencesSubmitted: false,
        year: honorsData.year || new Date().getFullYear()
    };
}

/**
 * Parse and normalize application data from GraphQL response
 * Handles AWSJson fields and applies data transformations only
 * Step computation is handled separately in stepDefinitions.js
 * @param {Object} rawData - Raw GraphQL response
 * @returns {Object} Parsed and normalized application data
 */
export function parseApplicationData(rawData) {
    if (!rawData) {
        return null;
    }

    // Parse JSON fields
    const selfService = safeParseJsonField(rawData.selfService, 'selfService');

    // System-wide portal availability (defaults to true if not provided)
    const selfServiceOpen = selfService?.isOpen ?? true;

    // Apply transformations and normalization
    const processedData = {
        emplid: rawData.emplid,
        selfServiceOpen, // Top-level system availability (V1 compatibility)
        selfService: selfService ? {
            ...selfService,
            deadline: selfService.deadline ? new Date(selfService.deadline).toLocaleDateString() : null
        } : null,
    };
    return processedData;
}